<template>
  <div>
    <div v-if="!acceptSuccess">
      <form @submit.prevent="createAcount" novalidate="novalidate">
        <div class="col-12 q-pa-md text-center">
          <p class="text-weight-bold">{{ getString('register.form.title') }}</p>
          <p>{{ getString('register.form.text') }}</p>
          <hr>
        </div>
        <div class="col-12 q-pb-sm q-pl-md q-pr-md">
          <q-field
              :error="$v.data.firstname.$invalid && validationActive"
              :error-label="getString('firstname')">
            <q-input
              color="white"
              type="text"
              :placeholder="getString('possesivePronoun.your') + ' ' + getString('firstname').toLowerCase()"
              inverted-light
              v-model="data.firstname"
              class="no-shadow bg-grey-11"
            />
          </q-field>
        </div>
        <div class="col-12 q-pb-md q-pl-md q-pr-md">
          <q-field
            :error="$v.data.surname.$invalid && validationActive"
            :error-label="getString('surname')">
            <q-input
              color="white"
              type="text"
              :placeholder="getString('possesivePronoun.your') + ' ' + getString('surname').toLowerCase()"
              inverted-light
              v-model="data.surname"
              class="no-shadow bg-grey-11"
            />
          </q-field>
        </div>
        <div class="col-12 q-pb-md q-pl-md q-pr-md">
          <div class="pw-requirements q-pa-md">
            <p class="text-weight-bold">{{ getString('password.requirements.head') }}</p>
            <ul>
              <li :class="{valid: validateNumberChars}" v-text="getString('password.requirements.characters') + ' ('+ data.password.length +')'"></li>
              <li :class="{valid: validateNumberDigits}" v-text="getString('password.requirements.digits')"></li>
              <li :class="{valid: validateNumberCaps}" v-text="getString('password.requirements.capitals')"></li>
              <li :class="{valid: validateNumberLower}" v-text="$store.state.stringsStore.language === 'nl' ? 'Minimaal 2 kleine letters' : 'At least 2 lower-case'"></li>
              <li :class="{valid: validateNumberSpecialChars}" v-text="getString('password.requirements.specialchars')"></li>
              <li>! ? $ % ^ &amp; * ( ) _ \ - + = { } [ ] : ; @ ' ~ # | &lt; , &gt; . /</li>
            </ul>
          </div>
        </div>
        <div class="col-12 q-pb-sm q-pl-md q-pr-md">
          <q-field
            :error="$v.data.password.$invalid && validationActive"
            :error-label="getString('form.error.pattern.password')">
            <q-input
              color="white"
              type="password"
              :placeholder="getString('possesivePronoun.your') + ' ' + getString('password_str').toLowerCase()"
              inverted-light
              v-model="data.password"
              class="no-shadow bg-grey-11"
            />
          </q-field>
        </div>
        <div class="col-12 q-pb-sm q-pl-md q-pr-md">
          <q-field
            :error="$v.data.repeatPassword.$invalid && validationActive"
            :error-label="getString('password.retype_error')">
            <q-input
              color="white"
              type="password"
              :placeholder="getString('password.retype')"
              inverted-light
              v-model="data.repeatPassword"
              class="no-shadow bg-grey-11"
            />
          </q-field>
        </div>
        <div class="col-12 q-pb-sm q-pl-md q-pr-md">
          <hr>
        </div>
        <div class="col-12 q-pb-sm q-pl-md q-pr-md">
          <q-select
            v-model="data.language"
            :float-label="getString('register.form.language')"
            :options="availableLang"
          />
        </div>
        <div class="col-12 q-pa-md">
          <q-btn
            :disable="$v.$invalid"
            :class="{'disabled-btn': $v.$invalid}"
            align="right"
            color="primary"
            :label="getString('register.form.button')"
            size="md"
            type="submit"
            class="float-right capitalize"
          />
        </div>
      </form>
      <div>&nbsp;</div>
    </div>
    <div class="col-12 q-pa-md text-center success" v-else>
      <p class="text-weight-bold">{{getString('register.success')}}</p>
    </div>
  </div>
</template>

<script>

import { helpers, required, sameAs } from 'vuelidate/lib/validators';
import qs from 'qs';
import getString from '@/helpers/GetStrings';

// Define custom validators
const alpha = helpers.regex('alpha', /^[a-zA-Z- ]*$/);
const pwRequirements = helpers.regex('pwRequirements', /^(?=.*[A-Z].*[A-Z])(?=.*[a-z].*[a-z])(?=.*[^\w\s].*[^\w\s])(?=.*\d.*\d)(?=(^.{10,}$))/);

export default {
  name: 'Accept',
  mounted() {
    if (this.$store.state.authStore.isAuthenticated) {
      this.$store.dispatch('authLogout');
    }

    this.email = this.$route.params.email;
    this.code = this.$route.params.code;

    // Check values in url if invitation is (still) valid
    this.checkInvite();
    // Show loader
    this.$q.loading.show();
  },
  data() {
    return {
      acceptSuccess: false,
      email: '',
      code: '',
      validationActive: false,
      data: {
        firstname: '',
        surname: '',
        password: '',
        repeatPassword: '',
        language: '',
        email: '',
        code: '',
      },
      availableLang: [
        {
          value: 'en',
          label: 'English',
        },
        {
          value: 'nl',
          label: 'Nederlands',
        },
      ],
    };
  },
  validations: {
    data: {
      firstname: {
        alpha,
        required,
      },
      surname: {
        alpha,
        required,
      },
      password: {
        required,
        pwRequirements,
      },
      repeatPassword: {
        required,
        sameAs: sameAs('password'),
      },
    },
  },
  methods: {
    getString,
    async checkInvite() {
      try {
        const response = await this.axios.get(`accept/check?code=${this.code}&email=${this.email}`);
        if (response) {
          this.$q.loading.hide();
        }
      } catch (error) {
        const self = this;
        setTimeout(() => {
          // Hide loader
          this.$q.loading.hide();
          this.$q.notify({
            message: getString('register.error.invalid'),
            position: 'center',
            timeout: 2000,
            color: 'negative',
            onDismiss() {
              self.$router.push('/login');
            },
          });
        }, 500);
      }
    },
    async createAcount() {
      this.$v.$touch();
      this.validationActive = true;
      if (!this.$v.$invalid) {
        const data = {
          firstname: this.data.firstname,
          surname: this.data.surname,
          password: this.data.password,
          language: this.data.language,
          code: this.code,
          email: this.email,
        };

        try {
          await this.axios.post('accept', qs.stringify(data));
          this.acceptSuccess = true;
          setTimeout(() => {
            this.$router.push('/dashboard');
          }, 3000);
        } catch (error) {
          this.$q.notify({
            message: getString('module.register.error.general'),
            position: 'center',
            timeout: 2000,
            color: 'negative',
          });
          console.warn(error);
        }
      }
    },
  },
  computed: {
    // The following 4 properties are to let the user know if the entered password is valid
    validateNumberChars() {
      return (this.data.password.length >= 10);
    },
    validateNumberDigits() {
      return /(?=.*\d.*\d)/.test(this.data.password);
    },
    validateNumberCaps() {
      return /(?=.*[A-Z].*[A-Z])/.test(this.data.password);
    },
    validateNumberLower() {
      return /(?=.*[a-z].*[a-z])/.test(this.data.password);
    },
    validateNumberSpecialChars() {
      return /(?=.*[^\w\s].*[^\w\s])/.test(this.data.password);
    },
  },
};
</script>

<style lang="stylus">
  @import '~variables';
    .disabled-btn
      background-color: lightgrey !important
  hr
    height 1px !important
    border none
    border-bottom 1px solid rgba(0, 0, 0, 0.075)

  .pw-requirements
    background-color $ctrl-yellow-lighten-3
    border #fcdf5f 1px solid
    ul
      padding-left .5rem
      list-style-position inside
      li
        line-height 1.5rem
        &.valid
          font-weight bold
          &:after
            content ' \2713'
            color #23DC3D
            font-weight bold
        &:last-child
          list-style none
</style>
